
/*
 * ESER ÇİÇEKÇİLİK
 * Canlı çiçek sipariş formu - V4 TEST
 * Türkiye saati, takvim, doğrulama ve sepete ekleme
 */
(() => {
  'use strict';

  const ZONE = 'Europe/Istanbul';

  const MONTHS = [
    'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs',
    'Haziran', 'Temmuz', 'Ağustos', 'Eylül',
    'Ekim', 'Kasım', 'Aralık'
  ];

  const SHORT_MONTHS = [
    'Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz',
    'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'
  ];

  const WEEKDAYS = [
    'Pazar', 'Pazartesi', 'Salı', 'Çarşamba',
    'Perşembe', 'Cuma', 'Cumartesi'
  ];

  const SLOTS = ['10:00 - 15:00', '15:00 - 21:00'];

  const CLOCK_MAX_AGE_MS = 150000;
  const CLOCK_REFRESH_MS = 45000;
  const MAX_FETCH_MS = 15000;

  const FEE_RATES = Object.freeze({
    'Adalar (Büyükada ya da Sedef)': 2000,
    'Beylikdüzü': 1500,
    'Büyükçekmece': 1500,
    'Çatalca': 2000,
    'Gebze': 2000,
    'Sarıyer': 1500,
    'Silivri': 2000
  });

  const FREE_ZONES = new Set([
    'Arnavutköy', 'Ataşehir', 'Avcılar',
    'Bağcılar', 'Bahçelievler', 'Bakırköy',
    'Başakşehir', 'Bayrampaşa', 'Beşiktaş',
    'Beykoz', 'Beyoğlu', 'Çekmeköy',
    'Esenler', 'Esenyurt', 'Eyüpsultan',
    'Fatih', 'Gaziosmanpaşa', 'Güngören',
    'Kadıköy', 'Kağıthane', 'Kartal',
    'Küçükçekmece', 'Maltepe', 'Pendik',
    'Sancaktepe', 'Sultanbeyli', 'Sultangazi',
    'Şile', 'Şişli', 'Tuzla', 'Ümraniye',
    'Üsküdar', 'Zeytinburnu'
  ]);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  });

  const isoDay = (y, m, d) =>
    `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

  const addDays = (iso, days) => {
    const [y, m, d] = iso.split('-').map(Number);
    return new Date(
      Date.UTC(y, m - 1, d + days)
    ).toISOString().slice(0, 10);
  };

  const dayFromISO = iso => {
    const [y, m, d] = iso.split('-').map(Number);
    return new Date(Date.UTC(y, m - 1, d));
  };

  const displayDate = iso => {
    const date = dayFromISO(iso);
    return `${WEEKDAYS[date.getUTCDay()]}, ${date.getUTCDate()} ${SHORT_MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
  };

  const longDate = iso => {
    const date = dayFromISO(iso);
    return `${date.getUTCDate()} ${MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
  };

  const monthIndex = (year, monthZero) =>
    year * 12 + monthZero;

  const calendarDate = (y, m, day) =>
    new Date(Date.UTC(y, m, day))
      .toISOString().slice(0, 10);

  function partsAt(epochMs) {
    const values = Object.fromEntries(
      formatter.formatToParts(new Date(epochMs))
        .filter(p => p.type !== 'literal')
        .map(p => [p.type, Number(p.value)])
    );

    return {
      date: isoDay(
        values.year,
        values.month,
        values.day
      ),
      hour: values.hour,
      minute: values.minute
    };
  }

  function init(root) {
    if (root.dataset.eserInitialized === 'true') return;
    root.dataset.eserInitialized = 'true';

    const hiddenDate = root.querySelector('[data-eser-date]');
    const trigger = root.querySelector('[data-eser-date-trigger]');
    const dateLabel = root.querySelector('[data-eser-date-label]');
    const popup = root.querySelector('[data-eser-calendar]');
    const daysContainer = root.querySelector('[data-eser-days]');
    const prev = root.querySelector('[data-eser-prev]');
    const next = root.querySelector('[data-eser-next]');
    const monthSelect = root.querySelector('[data-eser-month]');
    const yearSelect = root.querySelector('[data-eser-year]');
    const slot = root.querySelector('[data-eser-slot]');
    const status = root.querySelector('[data-eser-status]');
    const counter = root.querySelector('[data-eser-counter]');
    const message = root.querySelector('[data-eser-message]');

    const form = document.getElementById(
      root.dataset.productForm
    );

    const zone = root.querySelector(
      '[name="properties[Gönderim Bölgesi]"]'
    );

    const buyButton = form?.querySelector(
      'button[name="add"]'
    );

    const existingFeeWarning = root.querySelector(
      '[data-eser-fee-warning]'
    );

    const note = root.querySelector(
      '.eser-live-form__note'
    );

    if (existingFeeWarning) {
      existingFeeWarning.hidden = true;
    }

    if (note) {
      note.textContent =
        'TEST: Teslimat bedeli sepet sayfasında hesaplanır. Ödemeyi tamamlamayın.';
    }

    let submitting = false;
    let anchorMs = null;
    let anchoredAt = null;
    let pending = null;
    let viewYear = null;
    let viewMonth = null;
    let lastError = false;
    let requestNumber = 0;

    function serverTimeMs() {
      if (anchorMs === null || anchoredAt === null) {
        return null;
      }

      const elapsed = performance.now() - anchoredAt;

      if (
        elapsed < 0 ||
        elapsed > CLOCK_MAX_AGE_MS
      ) {
        return null;
      }

      return anchorMs + elapsed;
    }

    function trustedState() {
      const epoch = serverTimeMs();

      if (epoch === null) return null;

      const tr = partsAt(epoch);

      return {
        tr,
        first: tr.hour >= 21
          ? addDays(tr.date, 1)
          : tr.date,
        last: addDays(tr.date, 20)
      };
    }

    function updatePurchaseState() {
      if (!buyButton) return;

      buyButton.disabled =
        submitting ||
        !trustedState() ||
        !form;
    }

    function openCalendar() {
      if (trigger.disabled || !trustedState()) return;

      const { tr } = trustedState();
      const iso = hiddenDate.value || tr.date;

      const [y, m] = iso.split('-').map(Number);

      viewYear = y;
      viewMonth = m - 1;

      popup.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');

      renderCalendar();
    }

    function closeCalendar(restoreFocus = false) {
      if (popup.hidden) return;

      popup.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');

      if (restoreFocus) trigger.focus();
    }

    function fillMonths() {
      if (monthSelect.options.length) return;

      MONTHS.forEach((name, idx) => {
        monthSelect.add(
          new Option(name, String(idx))
        );
      });
    }

    function fillYears(baseYear) {
      const desired = [];

      for (
        let y = baseYear - 1;
        y <= baseYear + 2;
        y += 1
      ) {
        desired.push(y);
      }

      const existing = Array.from(yearSelect.options)
        .map(o => Number(o.value))
        .join(',');

      if (existing !== desired.join(',')) {
        yearSelect.replaceChildren();

        desired.forEach(y => {
          yearSelect.add(
            new Option(String(y), String(y))
          );
        });
      }
    }

    function renderCalendar() {
      if (popup.hidden) return;

      const state = trustedState();

      if (!state) {
        closeCalendar();
        return;
      }

      const { tr, first, last } = state;

      fillMonths();
      fillYears(Number(tr.date.slice(0, 4)));

      monthSelect.value = String(viewMonth);
      yearSelect.value = String(viewYear);

      const minMonth = monthIndex(
        Number(tr.date.slice(0, 4)) - 1, 0
      );

      const maxMonth = monthIndex(
        Number(tr.date.slice(0, 4)) + 2, 11
      );

      const currentMonth = monthIndex(
        viewYear, viewMonth
      );

      prev.disabled = currentMonth <= minMonth;
      next.disabled = currentMonth >= maxMonth;

      daysContainer.replaceChildren();

      const firstWeekday = (
        new Date(Date.UTC(viewYear, viewMonth, 1))
          .getUTCDay() + 6
      ) % 7;

      const numDays = new Date(
        Date.UTC(viewYear, viewMonth + 1, 0)
      ).getUTCDate();

      const cells = Math.ceil(
        (firstWeekday + numDays) / 7
      ) * 7;

      for (let idx = 0; idx < cells; idx += 1) {
        const day = idx - firstWeekday + 1;
        const iso = calendarDate(
          viewYear, viewMonth, day
        );

        const isAdjacent =
          day < 1 || day > numDays;

        const allowed =
          !isAdjacent &&
          iso >= first &&
          iso <= last;

        const btn = document.createElement('button');

        btn.type = 'button';
        btn.className = 'eser-date-picker__day';

        if (isAdjacent) {
          btn.classList.add(
            'eser-date-picker__day--adjacent'
          );
        }

        if (iso === tr.date) {
          btn.classList.add(
            'eser-date-picker__day--today'
          );
        }

        if (iso === hiddenDate.value) {
          btn.classList.add(
            'eser-date-picker__day--selected'
          );
        }

        btn.textContent = String(
          dayFromISO(iso).getUTCDate()
        );

        btn.disabled = !allowed;
        btn.setAttribute('aria-label', longDate(iso));

        if (iso === hiddenDate.value) {
          btn.setAttribute('aria-pressed', 'true');
        }

        if (allowed) {
          btn.addEventListener('click', () => {
            hiddenDate.value = iso;
            hiddenDate.setCustomValidity('');

            updateForm();
            closeCalendar(true);
          });
        }

        daysContainer.appendChild(btn);
      }
    }

    function updateForm() {
      const state = trustedState();

      if (!state) {
        trigger.disabled = true;

        dateLabel.textContent =
          'Sunucu saati kontrol ediliyor…';

        status.textContent = lastError
          ? 'Shopify saat bilgisi doğrulanamadı. Tarih seçimi kapalı; sayfayı yenileyin.'
          : 'Shopify üzerinden Türkiye saati kontrol ediliyor…';

        slot.disabled = true;

        slot.replaceChildren(
          new Option('Tarih seçimi bekleniyor', '')
        );

        closeCalendar();
        updatePurchaseState();
        return;
      }

      const { tr, first, last } = state;

      trigger.disabled = false;

      const selectedBefore = hiddenDate.value;

      if (
        selectedBefore &&
        (
          selectedBefore < first ||
          selectedBefore > last
        )
      ) {
        hiddenDate.value = '';
      }

      dateLabel.textContent = hiddenDate.value
        ? displayDate(hiddenDate.value)
        : 'Gönderim tarihi seçiniz';

      const oldSlot = slot.value;

      const todayCutoff =
        hiddenDate.value === tr.date &&
        tr.hour >= 15;

      const choices = todayCutoff
        ? SLOTS.slice(1)
        : SLOTS;

      slot.replaceChildren(
        new Option(
          hiddenDate.value
            ? 'Seçiniz'
            : 'Önce tarih seçiniz',
          ''
        )
      );

      choices.forEach(value => {
        slot.add(new Option(value, value));
      });

      slot.disabled = !hiddenDate.value;

      slot.value =
        hiddenDate.value && choices.includes(oldSlot)
          ? oldSlot
          : '';

      slot.setCustomValidity('');
      hiddenDate.setCustomValidity('');

      if (selectedBefore && !hiddenDate.value) {
        status.textContent =
          'Seçili tarih artık geçerli değil. Yeni tarih seçiniz.';
      } else if (tr.hour >= 21) {
        status.textContent =
          `Türkiye saati 21:00 sonrası: bugün seçilemez. ${longDate(first)} - ${longDate(last)} seçilebilir.`;
      } else if (todayCutoff) {
        status.textContent =
          'Bugün yalnızca 15:00 - 21:00 teslimat aralığı seçilebilir.';
      } else {
        status.textContent =
          `${longDate(first)} - ${longDate(last)} arasında teslimat günü seçebilirsiniz.`;
      }

      renderCalendar();
      updatePurchaseState();
    }

    async function refreshClock() {
      if (pending) return pending;

      pending = (async () => {
        const started = performance.now();

        try {
          const url = new URL(window.location.href);

          url.searchParams.delete('sections');

          url.searchParams.set(
            'section_id', 'eser-server-clock'
          );

          url.searchParams.set(
            '_eser_clock',
            `${++requestNumber}_${Math.floor(performance.now())}`
          );

          const controller = new AbortController();

          const timeout = window.setTimeout(
            () => controller.abort(), 12000
          );

          let response;

          try {
            response = await fetch(url.toString(), {
              method: 'GET',
              credentials: 'same-origin',
              cache: 'no-store',
              signal: controller.signal
            });
          } finally {
            window.clearTimeout(timeout);
          }

          if (!response.ok) {
            throw new Error(
              `Saat bölümü alınamadı (${response.status})`
            );
          }

          const markup = await response.text();

          const match = markup.match(
            /data-eser-server-time\s*=\s*["'](\d{10,13})["']/
          );

          if (!match) {
            throw new Error('Saat alanı bulunamadı');
          }

          let serverEpoch = Number(match[1]);

          if (
            serverEpoch < 1000000000 ||
            !Number.isFinite(serverEpoch)
          ) {
            throw new Error('Geçersiz sunucu saati');
          }

          if (serverEpoch > 9999999999) {
            serverEpoch = Math.floor(serverEpoch / 1000);
          }

          const finished = performance.now();
          const elapsed = finished - started;

          if (
            elapsed > MAX_FETCH_MS ||
            elapsed < 0
          ) {
            throw new Error('Saat yanıtı çok gecikti');
          }

          const header = response.headers.get('Date');

          if (!header) {
            throw new Error(
              'Sunucu HTTP Date başlığı bulunamadı'
            );
          }

          const headerMs = Date.parse(header);

          if (!Number.isFinite(headerMs)) {
            throw new Error(
              'Sunucu HTTP Date başlığı okunamadı'
            );
          }

          if (
            Math.abs(headerMs - serverEpoch * 1000) >
            120000
          ) {
            throw new Error(
              'Sunucu saat bilgisi önbellekte eskimiş'
            );
          }

          anchorMs =
            serverEpoch * 1000 +
            Math.floor(elapsed / 2);

          anchoredAt = finished;
          lastError = false;

        } catch (error) {
          anchorMs = null;
          anchoredAt = null;
          lastError = true;

          console.warn(
            '[Eser tarih kontrolü]',
            error
          );
        }

        updateForm();
      })();

      try {
        await pending;
      } finally {
        pending = null;
      }
    }

    function validate() {
      const state = trustedState();

      if (!state) {
        status.textContent =
          'Güncel Shopify saati doğrulanmadan tarih seçilemez.';

        refreshClock();
        return false;
      }

      const { tr, first, last } = state;

      if (
        !hiddenDate.value ||
        hiddenDate.value < first ||
        hiddenDate.value > last
      ) {
        status.textContent =
          'Lütfen geçerli bir teslimat tarihi seçin.';

        openCalendar();
        return false;
      }

      if (
        !slot.value ||
        (
          hiddenDate.value === tr.date &&
          tr.hour >= 15 &&
          slot.value === SLOTS[0]
        )
      ) {
        slot.setCustomValidity(
          'Geçerli teslimat aralığını seçin.'
        );

        slot.reportValidity();
        return false;
      }

      return true;
    }

    trigger.addEventListener('click', () => {
      popup.hidden
        ? openCalendar()
        : closeCalendar();
    });

    document.addEventListener('pointerdown', event => {
      if (
        !root.isConnected ||
        popup.hidden
      ) {
        return;
      }

      if (
        !root.querySelector('[data-eser-date-picker]')
          .contains(event.target)
      ) {
        closeCalendar();
      }
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !popup.hidden) {
        event.preventDefault();
        closeCalendar(true);
      }
    });

    monthSelect.addEventListener('change', () => {
      viewMonth = Number(monthSelect.value);
      renderCalendar();
    });

    yearSelect.addEventListener('change', () => {
      viewYear = Number(yearSelect.value);
      renderCalendar();
    });

    function moveMonth(direction) {
      const point = new Date(
        Date.UTC(viewYear, viewMonth + direction, 1)
      );

      viewYear = point.getUTCFullYear();
      viewMonth = point.getUTCMonth();

      renderCalendar();
    }

    prev.addEventListener('click', () => moveMonth(-1));
    next.addEventListener('click', () => moveMonth(1));

    slot.addEventListener('change', () => {
      slot.setCustomValidity('');
    });

    if (message) {
      message.addEventListener('input', () => {
        if (counter) {
          counter.textContent =
            `${message.value.length}/200`;
        }
      });
    }

    document.addEventListener('submit', async event => {
      if (
        !root.isConnected ||
        event.target !== form
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (submitting) return;

      const selectedZone = zone?.value || '';

      const expectedFee =
        Object.prototype.hasOwnProperty.call(
          FEE_RATES, selectedZone
        )
          ? FEE_RATES[selectedZone]
          : FREE_ZONES.has(selectedZone)
            ? 0
            : null;

      const shownFee = Number(
        zone?.selectedOptions?.[0]?.dataset?.eserFee
      );

      if (
        expectedFee === null ||
        expectedFee !== shownFee
      ) {
        status.textContent =
          'Geçersiz teslimat bölgesi. Tekrar seçiniz.';

        zone?.focus();
        return;
      }

      await refreshClock();

      if (!validate()) return;

      const requiredFields = [
        zone,
        root.querySelector(
          '[name="properties[Alıcı İsim-Soyisim]"]'
        ),
        root.querySelector(
          '[name="properties[Alıcı Telefon Numarası]"]'
        ),
        root.querySelector(
          '[name="properties[Gönderim Adresi]"]'
        ),
        slot
      ];

      for (const field of requiredFields) {
        if (!field || !field.value.trim()) {
          if (field) {
            field.setCustomValidity(
              'Lütfen bu alanı doldurun.'
            );

            field.reportValidity();

            field.addEventListener(
              'input',
              () => field.setCustomValidity(''),
              { once: true }
            );

            field.addEventListener(
              'change',
              () => field.setCustomValidity(''),
              { once: true }
            );
          } else {
            status.textContent =
              'Zorunlu form alanı bulunamadı.';
          }

          return;
        }

        field.setCustomValidity('');
      }

      const data = new FormData(form);
      const variantId = Number(data.get('id'));

      if (
        !Number.isSafeInteger(variantId) ||
        variantId <= 0
      ) {
        status.textContent =
          'Ürün varyantı bulunamadı. Sepete eklenmedi.';
        return;
      }

      const properties = {};

      for (const [key, value] of data.entries()) {
        const match =
          /^properties\[(.+)\]$/.exec(key);

        if (
          match &&
          typeof value === 'string' &&
          value.trim()
        ) {
          properties[match[1]] = value.trim();
        }
      }

      properties['Gönderim Tarihi'] =
        longDate(hiddenDate.value);

      
/*
 * ESER - Tek satırlık teknik sipariş kaydı
 *
 * Tarih ve bölge zaten müşterinin doldurduğu
 * alanlardan okunacak.
 *
 * Benzersiz kod, aynı ürün farklı alıcılara
 * eklendiğinde satırların birleşmesini önler.
 */

const eserUniqueId =
  window.crypto?.randomUUID?.() ||
  `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;

properties['_eser_ref'] =
  'C-' + eserUniqueId.replace(/-/g, '').slice(0, 18);


      submitting = true;
      updatePurchaseState();

      try {
        const prefix =
          window.Shopify?.routes?.root || '/';

        const response = await fetch(
          prefix + 'cart/add.js',
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                properties
              }]
            })
          }
        );

        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(
            result.description ||
            result.message ||
            'Sepete ekleme başarısız.'
          );
        }

        window.location.assign(
          window.routes?.cart_url ||
          prefix + 'cart'
        );

      } catch (error) {
        status.textContent =
          `Sepete eklenemedi: ${error.message}`;

        console.error(
          '[ESER ürün ekleme]',
          error
        );

      } finally {
        submitting = false;
        updatePurchaseState();
      }
    }, true);

    updatePurchaseState();

    window.addEventListener('focus', () => {
      refreshClock();
    });

    document.addEventListener(
      'visibilitychange',
      () => {
        if (!document.hidden) {
          refreshClock();
        }
      }
    );

    const timer = window.setInterval(() => {
      if (!root.isConnected) {
        window.clearInterval(timer);
        return;
      }

      if (
        serverTimeMs() === null ||
        performance.now() - anchoredAt >
          CLOCK_REFRESH_MS
      ) {
        refreshClock();
      } else {
        updateForm();
      }
    }, CLOCK_REFRESH_MS);

    if (message && counter) {
      counter.textContent =
        `${message.value.length}/200`;
    }

    updateForm();
    refreshClock();
  }

  const start = () => {
    document
      .querySelectorAll('[data-eser-live-form]')
      .forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }

  document.addEventListener(
    'shopify:section:load',
    start
  );
})();
